module.exports = __webpack_public_path__ + "img/th_TH.687b952.webp";